import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const hierarchyDetailsTodo = createAsyncThunk('hierarchyDetails', async ({ block_id, location_id, sub_location_id, staff_id, department_id, sub_cat_id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `/issued_asset_list`,
            params: {
                'block_id': block_id,
                'location_id': location_id,
                'sub_location_id': sub_location_id,
                'staff_id': staff_id,
                'department_id': department_id,
                'sub_cat_id': sub_cat_id,
                'pageSize': "",
                'pageNo': "",
                'search': "",
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const hierarchyDetailsSlice = createSlice({
    name: 'maintenanceHierarchyList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(hierarchyDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(hierarchyDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default hierarchyDetailsSlice.reducer;